// extracted by mini-css-extract-plugin
export default {"linkStyleCopy":"D9-z"};